/*eslint-disable no-whitespace-before-property */
class ClaimsList {
  constructor() {
    this.claimList = null;
    this.claimsListFull = null;
    this.claimsListFiltered = null;
    this.claimsListOID = [];

    //Claim Status Summary Status Filters
    this.filterSelected = false;
    this.claimType = null;
    this.memberName = null;
    this.claimStatus = null;
  }

  //Start of Claim Status Summary Status Filters methods
  getFilterSelected() {
    return this.filterSelected;
  }

  setFilterSelected(selectedFlag) {
    this.filterSelected = selectedFlag;
  }

  getClaimType() {
    return this.claimType;
  }

  getMemberName() {
    return this.memberName;
  }

  getClaimStatus() {
    return this.claimStatus;
  }

  setClaimType(claimType) {
    this.claimType = claimType;
  }

  setMemberName(memberName) {
    this.memberName = memberName;
  }

  setClaimStatus(claimStatus) {
    this.claimStatus = claimStatus;
  }
  //End of Claim Status Summary Status Filters methods

  getClaimsList() {
    return this.claimList;
  }

  setClaimsList(claimsList) {
    this.claimsList = claimsList;
  }

  getClaimsListFull() {
    return this.claimListFull;
  }

  setClaimsListFull(claimListFull) {
    this.claimListFull = claimListFull;
  }

  getClaimsListFiltered(claimsListFiltered) {
    this.claimsListFiltered = claimsListFiltered;
  }

  setClaimsListFiltered(claimsListFiltered) {
    this.claimsListFiltered = claimsListFiltered;
  }

  getClaimDetails(selectedIndex) {
    return this.claimsListOID[selectedIndex].claimDetailsResponse;
  }

  setClaimDetails(selectedIndex, claimDetailsResp) {
    this.claimsListOID[selectedIndex].claimDetailsResponse = claimDetailsResp;
  }

  resetClaimsList() {
    this.claimList = null;
    this.claimsListFull = null;
    this.claimsListFiltered = null;
    this.claimsListOID = [];

    //Claim Status Summary Status Filters
    this.filterSelected = false;
    this.claimType = null;
    this.memberName = null;
    this.claimStatus = null;
  }
}
export default new ClaimsList();
